<app-new-company (existingCompany)="useExistingCompany($event)" #company>
</app-new-company>
<div class="buttons">
  <button mat-stroked-button
          color="primary"
          (click)="cancel()">Anuluj</button>
  <button mat-raised-button
          color="primary"
          [disabled]="!company.companyForm.valid"
          (click)="add(company.companyForm.value)">
    Dodaj
  </button>
</div>
